import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Shared02Headings from "../../guestsharedcomponents/Shared02Headings/Shared02Headings";
import MainBtnLinkBio from "./MainBtnLinkBio/MainBtnLinkBio";
import SecundaryBtnLinkBio from "./SecundaryBtnLinkBio/SecundaryBtnLinkBio";

gsap.registerPlugin(ScrollTrigger);

const ContainerMain = styled.main`
  .cta-img {
    max-width: 20rem;
    margin: 0 auto -8rem auto;
    height: 20rem;

    img {
      object-position: top;
    }
  }

  .cta-logo {
    background: url("https://res.cloudinary.com/djiqf3usa/image/upload/v1770090701/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-academy-dark-gold-footer-background_xh9jry.webp");
    background-position: center;
    background-size: cover;
    max-width: 16rem;
    z-index: 1;
    position: relative;
    border-radius: 50%;
    padding: 4rem 1rem 3rem 2rem;
    margin: 0 auto;
    box-shadow:
      0 6px 20px -4px var(--main-btn-shadow),
      0 2px 20px -4px rgb(0 0 0 / 22%),
      0 0 10px -4px #fff;
  }

  .social-media {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 25rem;
    margin: 0 auto 4rem auto;
  }

  .social-media a {
    font-size: 2rem;
    color: rgb(136, 106, 45);
    border: solid 0.1rem rgb(136, 106, 45);
    padding: 0.8rem 1.3rem;
    border-radius: 1rem;
  }
`;

const P02LinkInBio = () => {
  useEffect(() => {
    const container_brand = document.querySelector(".container-brand");

    if (!container_brand) return;

    // Fade + parallax de la imagen
    gsap.to(container_brand, {
      opacity: 0,
      y: -40,
      ease: "none",
      scrollTrigger: {
        trigger: container_brand,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });
  }, []);

  const array_social = [
    {
      id: "1",
      icon: "fa-brands fa-instagram",
      link: "https://www.instagram.com/luisytayofficial/",
    },
    {
      id: "2",
      icon: "fa-brands fa-youtube",
      link: "https://www.youtube.com/@luisytayler",
    },
    {
      id: "3",
      icon: "fa-brands fa-tiktok",
      link: "https://www.tiktok.com/@luisytayofficial",
    },
  ];

  const array_direct_links = [
    {
      id: "1",
      icon: "https://res.cloudinary.com/djiqf3usa/image/upload/v1770568915/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/learn-sensual-bachata-online-lt-mastery_lp3z4y.webp",
      img_alt:
        "Learn sensual bachata online with LT Mastery using a structured step-by-step training system",
      link: "/#free-lesson",
      heading: "Start Your Free Lesson",
      version: "internal_link_button",
    },
    {
      id: "2",
      icon: "https://res.cloudinary.com/djiqf3usa/image/upload/v1770569176/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-and-tay-bachata-event-bookings-sensual-movement_i90pxa.webp",
      img_alt:
        "Book Luis and Tay for bachata events and festivals through Sensual Movement",
      link: "https://sensualmovementusa.com/hire-our-artists/",
      heading: "Event Bookings — Sensual Movement",
      version: "external_link_button",
    },
    {
      id: "3",
      icon: "https://res.cloudinary.com/djiqf3usa/image/upload/v1770589606/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/private-bachata-lessons-online-and-in-person-lt-mastery_dmjbbx.webp",
      img_alt:
        "Private bachata lessons and personalized dance coaching with Luis and Tay",
      link: "/private-lessons",
      heading: "Private Lessons & Coaching",
      version: "internal_link_button",
    },
    {
      id: "4",
      icon: "https://res.cloudinary.com/djiqf3usa/image/upload/v1770568916/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-and-tay-sensual-bachata-instructors_ynlqh6.webp",
      img_alt:
        "Luis and Tay, international sensual bachata instructors and founders of LT Mastery",
      link: "/private-lessons",
      heading: "About Luis & Tay",
      version: "internal_link_button",
    },
  ];

  const array_other_links = [
    {
      id: "1",
      icon: "https://res.cloudinary.com/djiqf3usa/image/upload/v1770664051/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-movement-artist-training-program-luis-and-tay_innedy.webp",
      img_alt:
        "Sensual Movement Artist training program led by Luis and Tay for dancers seeking professional growth",
      link: "https://sensualmovementusa.com/sensual-movement-usa-artist-development-program/",
      heading: "Become a Sensual Movement Artist",
      version: "external_link_button",
    },
    {
      id: "2",
      icon: "https://res.cloudinary.com/djiqf3usa/image/upload/v1770591442/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-and-tay-upcoming-bachata-events-and-workshops_oynrth.webp",
      img_alt:
        "Upcoming bachata events, workshops, and festival appearances by Luis and Tay",
      link: "/",
      heading: "Upcoming Events & Appearances",
      version: "internal_link_button",
    },
    {
      id: "3",
      icon: "https://res.cloudinary.com/djiqf3usa/image/upload/v1770591440/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-and-tay-sensual-bachata-youtube-channel_cvjus0.webp",
      img_alt:
        "Luis and Tay YouTube channel featuring sensual bachata tutorials, performances, and training insights",
      link: "https://www.youtube.com/@luisytayler",
      heading: "Luis & Tay on YouTube",
      version: "external_link_button",
    },
  ];

  return (
    <ContainerMain>
      <section className="t-container-bio t-pt-2 t-pb-6">
        <div className="container-brand t-mb-4">
          <div className="cta-img">
            <img
              src="https://res.cloudinary.com/djiqf3usa/image/upload/v1768603035/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-and-tay-sensual-bachata-online-instructors-hero_enmpdq.webp"
              alt=""
            />
          </div>

          <div className="wraper-logo">
            <div className="cta-logo">
              <img
                src="https://res.cloudinary.com/djiqf3usa/image/upload/v1770310563/Clients/LTMastery/Frontpage/Images/Logos/lt-mastery-favicon_wrxt0z.webp"
                alt=""
              />
            </div>
          </div>
        </div>

        <Shared02Headings
          options={{
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: false,
            container_desktop_styles: false,
            obj_heading: {
              main_text:
                "<span class='t-d-block'>Start <span class='t-enlace'>Learning Bachata </span></span> With Confidence",
              main_tag_version: "h1",
              main_text_css: "t-h-2",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "900",
                "margin-bottom": "1rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },
            obj_support_heading: false,

            obj_divider: {
              divider_mobile_styles: {
                width: "60%",
                background:
                  "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                margin: "0 auto 2rem auto",
              },
              divider_desktop_styles: {},
            },
            obj_paragraph: {
              main_text:
                "Train with Luis & Tay inside a structured online academy designed to help you move better, connect deeper, and grow with clarity on and off the dance floor.",
              main_tag_version: "p",
              main_text_css: "",
              paragraph_mobile_styles: {
                color: "#fff",
                "font-size": "1.4rem",
                "margin-bottom": "3rem",
                "text-align": "center",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              paragraph_desktop_styles: false,
            },
            obj_buttons: false,
            heading_version: "heading_01",
          }}
        />

        <div className="social-media">
          {array_social.map((info) => (
            <a
              key={info?.id}
              href={info?.link}
              target="_blank"
              rel="noreferrer"
            >
              <i className={info?.icon}></i>
            </a>
          ))}
        </div>

        {array_direct_links.map((info) => (
          <MainBtnLinkBio key={info?.id} options={{ objinfo: info }} />
        ))}

        <div className="t-flex-op1">
          {array_other_links.map((info) => (
            <SecundaryBtnLinkBio key={info?.id} options={{ objinfo: info }} />
          ))}
        </div>
      </section>
    </ContainerMain>
  );
};

export default P02LinkInBio;
